<template>
  <div>
    <pt-page-title title="创建订单">
    </pt-page-title>
    <pt-order-form ref="form" class="pt-order-form__withData" :groupList="groupList" @toSubmit="toSubmit" :customerLoading="loading">
    </pt-order-form>
  </div>
</template>

<script>
import { cashCount } from '@/utils/formUtils'
import PtOrderForm from './index'
export default {
  name: 'pt-order-form__withData',
  components: {
    'pt-order-form': PtOrderForm
  },
  data () {
    return {
      groupList: [],
      loading: false
    }
  },
  methods: {
    toSubmit (form) {
      let params = this.changeDate(form)
      this.loading = true
      this.$store.dispatch('getPlaceOrder', params).then(res => {
        history.go(-1)
        this.$message.success('下单成功')
        this.loading = false
      }).catch(errorMessage => {
        this.loading = false
        console.error(errorMessage)
        this.$message.error(errorMessage)
      })
    },
    changeDate (form) {
      let param = {
        mallOrderGoods: {
          goodsUniqueId: form.goodsId,
          name: form.name,
          number: form.number
        },
        mallUserCriteria: { whiteList: form.whiteList },
        mallOrderInvoice: form.mallOrderInvoice,
        shippingAddress: form.shippingAddress
      }
      if (form.specifyAmount) {
        param['specifyAmount'] = cashCount(form.specifyAmount)
      }
      if (form.specificationItem) {
        param.mallOrderGoods['specificationItem'] = JSON.parse(form.specificationItem)
      }
      return param
    },
    getGroupList () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 99999
        }
      }
      this.$store.dispatch('getGoodsGroup', data).then(res => {
        this.groupList = res.data
      }).catch(err => {
        this.$message(err || '获取商品分组列表失败')
      })
    }
  },
  created () {
    this.getGroupList()
  }
}

</script>
